module.exports = __webpack_public_path__ + "img/ip-cctvimg-2.96f04861.png";